"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHScrollView = void 0;
const KHContainer_1 = require("./KHContainer");
class KHScrollView extends KHContainer_1.KHContainer {
    /**
     *
     * @param scene Scene this scroll view belongs to.
     * @param x X-coordinate of the scroll view.
     * @param y Y-coordinate of the scroll view.
     * @param w Width of the display window.
     * @param h Height of the display window.
     * @param contents Container that the contents are all inside of.
     */
    constructor(scene, x, y, w, h, contents) {
        super(scene, x, y, w, h, 0x0, 0, 0, true);
        this.contents = contents;
        this.add(contents);
        this._scroll_bar = scene.add.sprite(0, 0, 'scroll_bar').setDepth(500).setPosition(this.c_w - 3, 0).setOrigin(0, 0);
        this._scroll_bar.setInteractive();
        this.add(this._scroll_bar);
        this._down_on_scroll_bar = false;
        this._scroll_bar.on('pointerdown', (pointer) => {
            this._down_on_scroll_bar = true;
            this.setScrollBarPosition(pointer.y - this.y - 4);
        });
        this.scene.input.on('pointermove', (pointer) => {
            if (!pointer.isDown) {
                this._down_on_scroll_bar = false;
            }
            else if (this._down_on_scroll_bar) {
                this.setScrollBarPosition(pointer.y - this.y - 4);
            }
        });
        this._scroll_bar.on('pointerup', (pointer) => {
            this._down_on_scroll_bar = false;
        });
        this.scene.input.on('wheel', (pointer, currentlyOver, dx, dy, dz, event) => {
            let scroll_strength = 9;
            let offset = pointer.deltaY > 0 ? -scroll_strength : (pointer.deltaY < 0 ? scroll_strength : 0);
            this.setScrollOffset(this.offX, this.offY + offset);
        });
        this.setScrollOffset(0, 0);
        this.recomputeForBounds();
    }
    getOffX() {
        return this.offX;
    }
    getOffY() {
        return this.offY;
    }
    recomputeForBounds() {
        if (this.contents.c_h > this.c_h) {
            this._scroll_bar.setVisible(true);
            this._scroll_bar.setInteractive();
        }
        else {
            this._scroll_bar.setVisible(false);
            this._scroll_bar.removeInteractive();
        }
    }
    setScrollBarPosition(y) {
        let percent = y / (this.c_h - 6);
        percent = Math.min(1, Math.max(0, percent));
        // let scroll_bounds = [this.contents.c_w - this.c_w, this.contents.c_h - this.c_h];
        this.setScrollOffset(this.offX, -percent * this.contents.c_h);
    }
    /**
     * Scrolls the view so that the given coordinates are all on-screen (if
     * possible). Coordinates should be in the space of the content container.
     */
    scrollToBounds(x, y, w, h, buffer = 0) {
        let newX = this.offX, newY = this.offY;
        x += buffer;
        y -= buffer;
        w += buffer * 2;
        h += buffer * 2;
        // Goes beyond right side bounds.
        if (x + w > this.offX + this.c_w)
            newX = this.c_w - (x + w);
        // Goes beyond left side bounds. If both this and the above are true,
        // will prefer the left side over the right.
        if (x < this.offX)
            newX = x;
        // Goes beyond bottom side bounds.
        if (y + h > -this.offY + this.c_h)
            newY = this.c_h - (y + h);
        // Goes beyond top side bounds. If both this and the above are true,
        // will prefer the top side over the bottom.
        if (y < -this.offY)
            newY = -y;
        this.setScrollOffset(newX, newY);
    }
    /**
     * Directly sets the scroll offset to this point. Useful if you want to
     * scroll to a specific point. If you want to keep a specific element
     * onscreen, use scrollToBounds.
     */
    setScrollOffset(x, y) {
        let scroll_bounds = [this.contents.c_w - this.c_w, this.contents.c_h - this.c_h];
        x = Math.min(0, Math.max(-scroll_bounds[0], x));
        y = Math.min(0, Math.max(-scroll_bounds[1], y));
        this.offX = x;
        this.offY = y;
        this.contents.setPosition(x, y);
        this._scroll_bar.setY((-y / scroll_bounds[1]) * (this.c_h - 6));
        // console.log(y, this._scroll_bar.y);
    }
}
exports.KHScrollView = KHScrollView;
